import React from 'react';

export default function MetadataModal({ metadata, onClose }) {
  if (!metadata) {
    return null; // Don't render if no metadata is provided
  }

  return (
    <div className="metadata-modal"> {/* Assuming this class provides overlay styling */}
      <div className="metadata-content"> {/* Assuming this class styles the modal box */}
        <h3>Metadane PDF</h3>
        <pre style={{ maxHeight: "300px", overflow: "auto", background: '#f5f5f5', border: '1px solid #ccc', padding: '10px' }}>
          {JSON.stringify(metadata, null, 2)}
        </pre>
        <button onClick={onClose} style={{ marginTop: 10 }} className="admin-btn admin-btn-cancel">
          Zamknij
        </button>
      </div>
    </div>
  );
}
